/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 *  Possible values: Appointment = 1, Request = 2, System = 3, Reminder = 4, Alert = 5, Contact = 6, AppointmentCreated = 7, AppointmentUpdated = 8, AppointmentCancelled = 9, DailyIncompleteRequests = 10, EmailChanged = 11, ContactCaptured = 12, VoiceMessage = 13
 */
export enum Routemize_Constants_NotificationType {
    APPOINTMENT = 'Appointment',
    REQUEST = 'Request',
    SYSTEM = 'System',
    REMINDER = 'Reminder',
    ALERT = 'Alert',
    CONTACT = 'Contact',
    APPOINTMENT_CREATED = 'AppointmentCreated',
    APPOINTMENT_UPDATED = 'AppointmentUpdated',
    APPOINTMENT_CANCELLED = 'AppointmentCancelled',
    DAILY_INCOMPLETE_REQUESTS = 'DailyIncompleteRequests',
    EMAIL_CHANGED = 'EmailChanged',
    CONTACT_CAPTURED = 'ContactCaptured',
    VOICE_MESSAGE = 'VoiceMessage',
}
